import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-profile-settings',
    templateUrl: './profile-settings.component.html',
    styleUrls: ['./profile-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileSettingsComponent implements OnInit {
    activeTab = 'personal';

    constructor(
        private route: ActivatedRoute,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        const activeTab = this.route.snapshot.paramMap.get('section');

        if (activeTab) {
            this.activeTab = activeTab;
            this.changeDetectorRef.detectChanges();
        }
    }
}
